import { ICON_STORAGE_PREFIX } from '@shared/config/urls'

export const getIconSrc = (icon: string, isCustomIcon: boolean) =>
  `${!isCustomIcon ? ICON_STORAGE_PREFIX : ''}${!isCustomIcon ? `${icon}.svg` : icon}`
